import { render, staticRenderFns } from "./GeneralSettings.yaml?vue&type=template&id=b835528a&component"
import script from "./GeneralSettings.yaml?vue&type=script&lang=ts&component"
export * from "./GeneralSettings.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports